<template>
	<AnemicButton @click.stop="onClick" :class="{ selected: didCurrentUserUpVote }" :loading="loading" tile class="pa-0 up-vote-button">
		<div class="display-flex flex-column"><SIcon class="mb-1" name="idea-upvote" :width="14" :height="12" /> {{ numOfUpVotes }}</div>
	</AnemicButton>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapActionsShorthand } from '@/store/utils/mappers';
import { voteForIdea, unvoteForIdea } from '@/store/modules/inspirationCenter/actions';

export default {
	name: 'UpVoteIdeaButton',
	props: { idea: { type: Object } },
	computed: {
		...mapGetters(['user']),
		numOfUpVotes() {
			return this.idea.account_idea?.voters?.length || 0;
		},
		didCurrentUserUpVote() {
			return this.idea.account_idea?.voters?.some((voter) => voter === this.user.id);
		},
	},
	methods: {
		...mapActionsShorthand({ unvoteForIdea, voteForIdea }),
		async upVoteIdea() {
			this.loading = true;
			await this.voteForIdea({ ideaId: this.idea.id });
			this.loading = false;
		},
		async downVoteIdea() {
			this.loading = true;
			await this.unvoteForIdea({ ideaId: this.idea.id });
			this.loading = false;
		},
		onClick() {
			if (this.didCurrentUserUpVote) {
				this.downVoteIdea();
			} else {
				this.upVoteIdea();
			}
		},
	},
	data() {
		return {
			loading: false,
		};
	},
};
</script>

<style scoped lang="scss">
.up-vote-button {
	width: 100% !important;
	height: 49px !important;
	font-size: 14px !important;
	color: #292829 !important;
	border-radius: 7px !important;
	letter-spacing: 0px !important;
	font-weight: normal !important;
	background: var(--white) !important;
	border: 1px solid #6964eb !important;
	&.selected {
		background: #f3f3fd !important;
	}
}
</style>
